import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../Shared/Popup/PopUp';
import TextArea from '../../Shared/TextArea/TextArea';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import EpiContext from '@episerver/spa-core/Spa';
import { getReportParams, report } from '../../../middleware/report';
import successIcon from './images/success-icon.svg';
import errorIcon from './images/error-icon.svg';

const GenericGuideFeedback = (props) => {    
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [isGuideHelped, setIsGuideHelped] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [sendFeedbackStatus, setSendFeedbackStatus] = useState('');
    const [messageValidationError, setMessageValidationError] = useState('');
    const [genericGuideTitle, setGenericGuideTitle] = useState('');

    useEffect(() => {
        async function fetchData() {
            let content = await EpiContext.loadContentByPath(window.location.pathname);            
            const genericGuideTitleBlock = content.mainContentArea.expandedValue?.find(x=> x.contentType[1] == 'GenericGuideTitleBlock');
            setGenericGuideTitle(genericGuideTitleBlock?.title?.value);
            reportDWH({ actionType: 'SupportGuidesOnePage', status: 'Completed', messageText: 'SupportGuidesOnePage Displayed', genericGuideTitle: genericGuideTitleBlock?.title?.value });
          }
          fetchData();
    }, []);

    return (
        <div className='generic-guide-feedback'>
            {
                isGuideHelped ? (
                    <div className='guide-helped-text' dangerouslySetInnerHTML={{ __html: props.iContent.guideHelpedText?.value }}></div>
                ) : (
                    <>
                        <div className='title'> {props.iContent.title?.value} </div>
                        <div className='buttons-wrapper'>
                            <a href='#' onClick={(e) => handleButtonYesClick(e)}> כן </a>
                            <a href='#' onClick={(e) => handleButtonNoClick(e)}> לא </a>
                        </div>                    
                    </>
                )
            }

            <PopUp showPopUp={isDisplayPopup} onClose={handleClosePopup}>
                {renderPopup()}
            </PopUp>

        </div>
    );

    function renderPopup() {
        switch (sendFeedbackStatus) {
            case '':
                return <>
                    <div className='popup-title'> {props.iContent.popupTitle?.value} </div>
                    <div className='popup-sub-title'> {props.iContent.popupSubTitle?.value} </div>
                    <div className='field-wrapper'>
                        <TextArea
                            maxLength={300}
                            className='popup-textArea'
                            value={feedbackMessage}
                            onChange={(val)=> handleTextAreaChange(val)}
                            placeholder='ספרו לנו איך נוכל לייעל את המדריך' 
                            error={messageValidationError} 
                        />               
                    </div>
                    <div className='popup-button-wrapper'>
                        <BtnSubmit text='שלח' onclick={handleSendFeedback} formid='popup-feedback' />
                    </div>
                </>;
            case 'success':
                return <>
                    <div className='popup-icon-success' style={{backgroundImage:successIcon.bg()}}></div>
                    <div className='popup-bold-message'> {props.iContent.successText?.value} </div>
                    <div className='popup-button-wrapper'>
                        <BtnSubmit text='סיום' onclick={handleClosePopup} formid='popup-feedback' />
                    </div>
                </>;
            case 'error':
                return <>
                    <div className='popup-icon-error' style={{backgroundImage:errorIcon.bg()}}></div>
                    <div className='popup-bold-message'> מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת </div>
                    <div className='popup-button-wrapper'>
                        <BtnSubmit text='הבנתי, תודה' onclick={handleClosePopup} formid='popup-feedback' />
                    </div>                
                </>;
        }
    };


    function handleTextAreaChange(value) {
        setFeedbackMessage(value);

        if (!value) {
            setMessageValidationError('נא להזין טקסט');
        }
        else {
            setMessageValidationError('');
        }
    }
    
    function handleButtonYesClick(e) {
        e.preventDefault();
        setIsGuideHelped(true);
        reportDWH({ actionType: 'SupportGuidesOnePage', status: 'Completed', messageText: 'Guide Helped Clicked' });
    }

    function handleButtonNoClick(e) {
        e.preventDefault();
        setIsDisplayPopup(true);     
        reportDWH({ actionType: 'SupportGuidesOnePage', status: 'Completed', messageText: 'Guide Not Helped Clicked' });   
    }

    function handleClosePopup() {
        setIsDisplayPopup(false);
        setSendFeedbackStatus('');
        setMessageValidationError('');

    }

    async function handleSendFeedback() {

        if (!feedbackMessage) {
            setMessageValidationError('נא להזין טקסט');
            return;
        }

        setMessageValidationError('');

        try {
            props.showAppLoader();
            const params = {
                email: props.iContent.popupEmailToFeedback?.value,
                guideName: props.iContent.guideName?.value,
                guideUrl: document.location.href,
                message: feedbackMessage
            }
            const result = await ProviderManager.getProviderData('sendGuideFeedback', params);

            if (result?.Body) {
                setSendFeedbackStatus('success');
                reportDWH({ actionType: 'SupportGuidesOnePage', status: 'Completed', messageText: 'Guide Not Helped Review Sent' });
            }
            else {
                setSendFeedbackStatus('error');
            }

        } catch (error) {

        } finally {
            props.hideAppLoader();
        }
    }

    function reportDWH(params) {
        const isAuthenticated = props.loginData?.isFullAuthenticated || props.loginData?.isOtpAuthenticated || props.loginData?.isOtpExtendedAuthenticated || props.loginData?.isSilentOtpAuthenticated;

        let reportParams = getReportParams();
        reportParams.area = 'Support';
        reportParams.subArea = 'SupportGuides';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = params.actionType;
        reportParams.status = params.status;
        reportParams.messageText = params.messageText;
        reportParams.customerName = isAuthenticated ? `${props.loginData?.userDetails?.firstName} ${props.loginData?.userDetails?.lastName}` : '';
        reportParams.email = '';
        reportParams.banId = '';
        reportParams.idNumber = props.loginData?.userDetails?.IDNumber ?? '';
        reportParams.subscriber = props.loginData?.userDetails?.contactNumber ?? '';
        reportParams.param1 = params.genericGuideTitle ? params.genericGuideTitle : genericGuideTitle;
        reportParams.param2 = feedbackMessage;
        reportParams.param9 = isAuthenticated ? (props.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי') : ''
        reportParams.param10 = props.loginData?.isFullAuthenticated ? 'לקוח' : props.loginData?.isOtpExtendedAuthenticated ? 'OTP מורחב' : props.loginData?.isOtpAuthenticated ? 'OTP' : '';
        report(reportParams);
    }

};

const mapStateToProps = (state) => {
    return {
        loginData: state.authentication.loginData
    };
};

const mapDispatchToProps = {
    showAppLoader, 
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideFeedback);